/* @pareto-engineering/generator-front 1.1.1-alpha.2 */
import * as React from 'react';
import PropTypes from 'prop-types';
import styleNames from '@pareto-engineering/bem/exports';
import { LoadingCircle, ProgressBar, Tooltip } from "../../../../../a";

// Local Definitions

import "./styles.scss";
import { Button } from "../../../../../b";
import { getFileType, getFileTypeFromUrl } from "../../utils";
const baseClassName = styleNames.base;
const componentClassName = 'file-preview';
const statusColorMap = {
  pending: 'yellow',
  error: 'red',
  success: 'green'
};
const FILE_UPLOAD_COMPLETE_PROGRESS = 100;

/**
 * This is the component description.
 */
const Preview = ({
  id,
  className: userClassName,
  style,
  file,
  handleDelete,
  uploadStatus,
  color,
  uploadProgress,
  writeOnly
  // ...otherProps
}) => {
  const isFileObject = file instanceof File;
  const type = isFileObject ? getFileType(file) : getFileTypeFromUrl(file?.url);
  const statusColor = statusColorMap[uploadStatus] ?? color;
  const isPending = uploadStatus === 'pending';
  // isPreview means the file is uploaded and previewed while other files can still be uploaded
  const isSuccess = uploadStatus === 'success' || file?.isPreview;
  const handlePreview = () => {
    if (!isFileObject) {
      window.open(file.url, '_blank');
    }
  };
  const canDelete = file?.isPreview || isFileObject;
  const isFileBroken = !writeOnly && !file?.url;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "identity"
  }, /*#__PURE__*/React.createElement("span", {
    className: ['type', type.toLowerCase()].filter(e => e).join(' ')
  }, type), /*#__PURE__*/React.createElement("span", {
    title: file.name,
    className: "name"
  }, file.name), isFileBroken ? /*#__PURE__*/React.createElement(Tooltip, {
    description: "bulk-updates-text",
    content: /*#__PURE__*/React.createElement("p", null, "This file doesn't have a link or the link is invalid.")
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon x-ui-icons c-x"
  }, "h")) : /*#__PURE__*/React.createElement(Button, {
    color: "ui-icons",
    isCompact: true,
    isSimple: true,
    onClick: () => canDelete ? handleDelete() : handlePreview()
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, canDelete ? 'Y' : '9'))), writeOnly && /*#__PURE__*/React.createElement("div", {
    className: `progress-status x-${statusColor}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "status"
  }, isPending ? /*#__PURE__*/React.createElement(LoadingCircle, {
    className: `x-${statusColor}`,
    heightWidth: "1rem",
    color: statusColor
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "icon"
  }, isSuccess ? 'I' : 'Y'), /*#__PURE__*/React.createElement("span", null, isSuccess ? 'Uploaded' : 'Error'))), /*#__PURE__*/React.createElement(ProgressBar, {
    color: statusColor,
    progress: isPending ? uploadProgress : FILE_UPLOAD_COMPLETE_PROGRESS,
    height: "3px"
  })));
};
Preview.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string),
  /**
   * The base color of the file preview
   */
  color: PropTypes.string,
  /**
   * The upload progress of the file
   */
  uploadProgress: PropTypes.number,
  /**
   * Whether the preview is used in a context where the user can upload new files
   */
  writeOnly: PropTypes.bool
};
Preview.defaultProps = {
  color: 'green',
  uploadProgress: 0
};
export default Preview;